import { Circle as CircleStyle, Fill, Style, Stroke } from "ol/style";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { isSD } from "./style/crosslink";

export function addCrosslinkHoverLayer(map) {
  const vectorSource = new VectorSource({});

  const styleFunction = function (feature) {
    const geometryType = feature.getGeometry().getType();
    // Endpoint markers carry a Point geometry + a markerColor; handle them
    // before isSD(), which assumes a line feature with an id.
    if (geometryType === "Point") {
      return new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({ color: feature.get("markerColor") }),
          stroke: new Stroke({ color: "white", width: 2 }),
        }),
        zIndex: 20,
      });
    }
    // The connecting ribbon between the matched road and lane sections —
    // semi-transparent fill drawn behind the section lines. Turns red when the
    // relation is out-of-bounds (a member's role runs past its own length).
    if (geometryType === "Polygon") {
      const outOfBounds = feature.get("outOfBounds");
      return new Style({
        fill: new Fill({
          color: outOfBounds ? "rgba(255, 0, 0, 0.3)" : "rgba(0, 90, 255, 0.3)",
        }),
        stroke: new Stroke({
          color: outOfBounds ? "rgba(220, 0, 0, 0.7)" : "rgba(0, 70, 220, 0.7)",
          width: 1,
        }),
        zIndex: 5,
      });
    }
    // Outer stroke matches the segment's own colour (road green / lane blue);
    // inner stroke is the matching lighter shade.
    let LINE_COLOR;
    let FILL_COLOR;
    if (isSD(feature)) {
      LINE_COLOR = "green";
      FILL_COLOR = "#c8f5c8"; // light green
    } else {
      LINE_COLOR = "blue";
      FILL_COLOR = "#d4ecfb"; // light blue
    }
    const styles = [
      // linestring
      new Style({
        stroke: new Stroke({
          color: LINE_COLOR,
          width: 7,
        }),
        zIndex: 12,
      }),
      new Style({
        stroke: new Stroke({
          color: FILL_COLOR,
          width: 5,
        }),
        zIndex: 13,
      }),
    ];
    return styles;
  };

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    style: styleFunction,
  });

  vectorLayer.setZIndex(100);
  map.addLayer(vectorLayer);
  map.on("click", function () {
    vectorSource.clear();
  });
  return vectorLayer;
}
